export default {
  title: 'Informação legal',
  subtitle: 'Aparece no rodapé da sua loja online e do seu site apenas depois de a guardar.',
  card_title: 'Informação legal',
  placeholder: 'Introduza a sua informação legal',
  status: {
    saved: 'Guardado',
    not_shown: 'Ainda não aparece na sua loja nem no seu site',
    unsaved: 'Alterações por guardar — a sua loja e o seu site mostram a última versão guardada',
  },
  save: 'Guardar',
  retry: 'Tentar novamente',
  preview: {
    title: 'Pré-visualização do rodapé (loja e site)',
    terms: 'Termos',
    privacy: 'Privacidade',
    cookies: 'Cookies',
    imprint: 'Informação legal',
  },
  toasts: {
    saved: 'Informação legal guardada',
    save_failed: 'Não foi possível guardar a informação legal. Tente novamente.',
    load_failed: 'Não foi possível carregar a informação legal. Recarregue a página.',
  },
};
